import React from 'react';
import { Navigate } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import PageLoader from './PageLoader';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
  const { data: profile, isLoading } = useProfile();
  
  // Пока загружается профиль, показываем загрузчик
  if (isLoading) {
    return <PageLoader />;
  }
  
  // Проверяем права доступа
  const hasAdminAccess = profile?.is_system_admin || profile?.is_user_manager || false;
  
  // Если нет прав, перенаправляем на dashboard
  if (!hasAdminAccess) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedAdminRoute;
